import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black py-12 text-white text-center">
      <p className="text-lg font-medium text-gray-300 hover:text-cyan-400 transition-all duration-300 ease-in-out drop-shadow-glow">
        © 2025 SKYZM | All Rights Reserved
      </p>
    </footer>
  );
};

export default Footer;